// Auth feature endpoints - easy to change when server/URL changes

const BASE_URL = 'https://auth-446608.as.r.appspot.com/';

export const AUTH_ENDPOINTS = {
  // Password Authentication
  passwordLogin: '/api/public/auth/password/login',
  passwordRegister: '/api/public/auth/password/register',

  // OTP Authentication
  otpLogin: '/api/public/auth/otp/login',
  otpRequest: '/api/public/auth/otp/request',

  // Private endpoints (require authentication)
  me: '/api/private/auth/me',
  logout: '/api/private/auth/logout',
  refresh: '/api/private/auth/refresh',
} as const;

// Helper to get full URL
export const getAuthURL = (endpoint: keyof typeof AUTH_ENDPOINTS): string => {
  return `${BASE_URL}${AUTH_ENDPOINTS[endpoint]}`;
};

// Export individual URLs for convenience
export const AUTH_URLS = {
  passwordLogin: getAuthURL('passwordLogin'),
  passwordRegister: getAuthURL('passwordRegister'),
  otpLogin: getAuthURL('otpLogin'),
  otpRequest: getAuthURL('otpRequest'),
  me: getAuthURL('me'),
  logout: getAuthURL('logout'),
  refresh: getAuthURL('refresh'),
} as const;